module.exports = __webpack_public_path__ + "static/img/14.cc6e229.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/14.png
// module id = v+R/
// module chunks = 0